// extracted by mini-css-extract-plugin
export default {"Way":"Way_Way__drRBL","Header":"Way_Header__XXZeg","Main":"Way_Main__-QC+c"};